import { useMutation, useQuery } from '@apollo/client';
import {
  Alert,
  Box,
  Divider,
  Hidden,
  Page,
  PageBlock,
  Text,
  TextLink,
} from 'braid-design-system';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import { SiteWideFooter } from 'src/components/SiteWideFooter';
import { useAuth } from 'src/hooks/auth';

import EXPIRED_AD_RENEW from './queries/expiredAdRenew';
import USER_DETAILS from './queries/userDetails';

// Todo: codegen to get response types for all our queries
interface User {
  user: {
    firstName: string;
    lastName: string;
    emailAddress: string;
  };
}

const RenewListing = () => {
  const {
    data,
    loading: queryLoading,
    error: queryError,
  } = useQuery<User>(USER_DETAILS);
  const [
    postExpiredAdEmail,
    { error: mutationError, called, loading: mutationLoading },
  ] = useMutation(EXPIRED_AD_RENEW);

  const { getAuthToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAuthToken();
    if (Boolean(token) && data && !queryLoading && !called) {
      postExpiredAdEmail({
        variables: {
          input: {
            emailAddress: data.user.emailAddress,
            firstName: data.user.firstName,
            lastName: data.user.lastName,
          },
        },
      });
    }
    if (called && !mutationLoading && !mutationError) {
      navigate('/sell/renew-listing/success');
    }
  });

  return (
    <Page footer={<SiteWideFooter />} footerPosition="belowFold">
      <Hidden below="tablet">
        <Divider />
      </Hidden>

      <Box paddingTop="xlarge">
        <PageBlock width="small">
          {(queryLoading || mutationLoading || !called) && !queryError && (
            <CustomLoader />
          )}
          {(queryError || mutationError) && (
            <Alert tone="critical">
              <Text>
                Sorry, something went wrong processing your request, please{' '}
                <TextLink
                  href="https://www.seekbusiness.com.au/contact-us"
                  hitArea="large"
                >
                  contact us
                </TextLink>
              </Text>
            </Alert>
          )}
        </PageBlock>
      </Box>
    </Page>
  );
};

export default RenewListing;
